import sal from "./sal.js";

let $ = jQuery;

const makePropertyCard = propertyData => {
  let imageUrl = propertyData._embedded["wp:featuredmedia"][0].media_details.sizes.full.source_url;
  let imageWidth = propertyData._embedded["wp:featuredmedia"][0].media_details.sizes.full.width;
  let imageHeight = propertyData._embedded["wp:featuredmedia"][0].media_details.sizes.full.height;
  let communityLink = propertyData.link;
  let external_linkUrl = propertyData.acf.properties.property_website_link.url;
  let communityLinkRel = "";
  let communityLinkTarget = "_self";
  if (external_linkUrl) {
    communityLink = external_linkUrl;
    communityLinkTarget = "_blank";
    communityLinkRel = "noopener";
  }
  let city = propertyData.acf.properties.city;
  let state = propertyData.acf.properties.state;
  let street = propertyData.acf.properties.street;
  let zip = propertyData.acf.properties.zip_code;
  let $card = $('<div class="card property-card">')
    .attr({
      "data-city": propertyData.acf.properties.city,
      "data-state": propertyData.acf.properties.state,
      "data-sal": "fade",
      "data-sal-delay": "300",
      style: "--sal-duration: 2s; --sal-delay: 2s;"
    })
    .append(
      $("<a>")
        .attr({
          href: communityLink,
          rel: communityLinkRel,
          target: communityLinkTarget
        })

        .append(
          $("<img>").attr({
            src: imageUrl,
            width: imageWidth,
            height: imageHeight
          }),
          $("<div>")
            .addClass("details")
            .append($("<h2>").text(propertyData.title.rendered), $("<p>").html(`${street}<br/>${city}, ${state} ${zip}`))
        )
    );
  return $card;
};

const buildNewPropertyCards = function (nextPropertyList) {
  let newPropertyCards = nextPropertyList.map(makePropertyCard);
  return newPropertyCards;
};

export const loadMorePropertyCards = function (event) {
  let $propertyLoadMoreButton = event.data.loadMoreButton;
  let propertyReqSettings = event.data.propertyReqSettings;
  console.log("property req settings: ", propertyReqSettings);
  let postReqLimit = propertyReqSettings.limit;
  let postNumberOffset = propertyReqSettings.offset;
  let locationParam = "";
  if (propertyReqSettings.filterValues.state) {
    locationParam += `&location=${propertyReqSettings.filterValues.state}`;
  }
  if (propertyReqSettings.filterValues.city) {
    locationParam += `&location=${propertyReqSettings.filterValues.city}`;
  }
  $.ajax({
    // url: `/wp-json/wp/v2/properties?_embed&orderby=title&order=asc&per_page=${postReqLimit}&offset=${postNumberOffset}${locationParam}`,
    url: `/wp-json/wp/v2/properties?_embed&orderby=street_number_only&order=asc&per_page=${postReqLimit}&offset=${postNumberOffset}${locationParam}`,
    method: "GET",
    dataType: "json"
  }).done(function (data, textStatus, jqXHR) {
    console.log(data);
    let newCards = buildNewPropertyCards(data);
    console.log("new cards: ", newCards);
    event.data.propertyList.append(newCards);
    sal();
    // window.propertyReq.offset += postReqLimit;
    // window.propertyReq.nextOffset();
    propertyReqSettings.setNextOffset();
    let totalProperties = parseInt(jqXHR.getResponseHeader("x-wp-total"), 10);
    console.log("OFFSET: ", propertyReqSettings.offset);
    console.log("TOTAL PROPERTIES: ", totalProperties);
    if (propertyReqSettings.offset >= totalProperties) {
      $propertyLoadMoreButton.css("display", "none");
    } else {
      $propertyLoadMoreButton.css("display", "block");
    }
  });
};
